/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
    CustomAuthConnectResponseOneOf,
    instanceOfCustomAuthConnectResponseOneOf,
    CustomAuthConnectResponseOneOfFromJSON,
    CustomAuthConnectResponseOneOfFromJSONTyped,
    CustomAuthConnectResponseOneOfToJSON,
} from './CustomAuthConnectResponseOneOf';
import {
    CustomAuthConnectResponseOneOf1,
    instanceOfCustomAuthConnectResponseOneOf1,
    CustomAuthConnectResponseOneOf1FromJSON,
    CustomAuthConnectResponseOneOf1FromJSONTyped,
    CustomAuthConnectResponseOneOf1ToJSON,
} from './CustomAuthConnectResponseOneOf1';

/**
 * @type CustomAuthConnectResponse
 * Response from /custom-auth/connect. Exactly one of redirect or connection is set. A redirect means the client should open the URL and call again with sessionId + callbackParams; a connection means the flow is complete.
 * @export
 */
export type CustomAuthConnectResponse = CustomAuthConnectResponseOneOf | CustomAuthConnectResponseOneOf1;

export function CustomAuthConnectResponseFromJSON(json: any): CustomAuthConnectResponse {
    return CustomAuthConnectResponseFromJSONTyped(json, false);
}

export function CustomAuthConnectResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomAuthConnectResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return { ...CustomAuthConnectResponseOneOfFromJSONTyped(json, true), ...CustomAuthConnectResponseOneOf1FromJSONTyped(json, true) };
}

export function CustomAuthConnectResponseToJSON(value?: CustomAuthConnectResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfCustomAuthConnectResponseOneOf(value)) {
        return CustomAuthConnectResponseOneOfToJSON(value as CustomAuthConnectResponseOneOf);
    }
    if (instanceOfCustomAuthConnectResponseOneOf1(value)) {
        return CustomAuthConnectResponseOneOf1ToJSON(value as CustomAuthConnectResponseOneOf1);
    }

    return {};
}

